"use strict";
import { reportMisplacedCsrfMeta } from "./csrf_report";
const CSRF_META = 'meta[name="csrf-token"]';
let reportedMisplacedMeta = false;
function misplacedCsrfMeta() {
  const meta = document.querySelector(CSRF_META);
  if (meta && !reportedMisplacedMeta) {
    reportedMisplacedMeta = true;
    reportMisplacedCsrfMeta(meta);
  }
  return meta;
}
function csrfMeta() {
  var _a, _b;
  return (_b = (_a = document.head) == null ? void 0 : _a.querySelector(CSRF_META)) != null ? _b : misplacedCsrfMeta();
}
export function csrfToken() {
  const meta = csrfMeta();
  return meta && meta.content !== "" ? meta.content : null;
}
export function setCsrfToken(token) {
  const meta = csrfMeta();
  if (meta) {
    meta.content = token;
  }
}
